const Filter = ({ filters, onFilterChange }) => {
  const handleChange = (key, value) => {
    onFilterChange(key, value);
  };

  return (
    <div className="flex flex-wrap justify-end items-start gap-3">
      {filters.map((filter) => (
        <div key={filter.key} className="flex-1 min-w-[150px]">
          <label
            htmlFor={filter.key}
            className="text-sm block mb-1 relative font-inter left-[1px]"
          >
            {filter.placeholder}
          </label>
          {filter.type === "text" && (
            <input
              id={filter.key}
              type="text"
              className="w-full p-2 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder={filter.placeholder}
              value={filter.value || ""}
              onChange={(e) => handleChange(filter.key, e.target.value)}
            />
          )}
          {filter.type === "number" && (
            <input
              id={filter.key}
              type="number"
              className="w-full p-2 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder={filter.placeholder}
              value={filter.value || ""}
              onChange={(e) => handleChange(filter.key, e.target.value)}
            />
          )}
          {filter.type === "select" && (
            <select
              id={filter.key}
              className="w-full p-2 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={filter.value || ""}
              onChange={(e) => handleChange(filter.key, e.target.value)}
            >
              <option value="">{filter.placeholder}</option>
              {filter.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
          {filter.type === "date" && (
            <input
              id={filter.key}
              type="date"
              className="w-full p-2 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={filter.value || ""}
              onChange={(e) => handleChange(filter.key, e.target.value)}
            />
          )}
          {filter.type === "datetime" && (
            <input
              id={filter.key}
              type="datetime-local"
              className="w-full p-2 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={filter.value || ""}
              onChange={(e) => handleChange(filter.key, e.target.value)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Filter;
